import { Injectable, signal } from '@angular/core';
import { TicketType } from '@app/core/constants/app.constants';

@Injectable({ providedIn: 'root' })
export class SessionContextService {
  private readonly _tenantId = signal<string | null>(null);
  private readonly _ticketType = signal<TicketType | null>(null);
  private readonly _token = signal<string | null>(null);

  readonly tenantId = this._tenantId.asReadonly();
  readonly ticketType = this._ticketType.asReadonly();
  readonly token = this._token.asReadonly();

  setTenantId(id: string) { this._tenantId.set(id); }
  setTicketType(type: TicketType) { this._ticketType.set(type); }
  setToken(token: string) { this._token.set(token); }
}
